"use client"
import { ReactNode } from "react";
import { handleRedirection } from "../../utils/helper";
import { useRouter } from "next/navigation";
import { dataLayer } from "@repo/analytics/data-layer-utils";
import { dlElementConstants, dlEventConstants, componentNameConstants } from "@repo/analytics/data-layer.constants";
import {
  useAppSelector,
  selectIsAuthSuccessOrPerpetual,
  store,
  setIsCommonSsoModalVisible,
} from "@repo/web-store";
import { stringToBoolean } from "@repo/shared-utils/pwa-utils";


const RedirectionHandler = ({ children, url, inNewTab, headerName, section_title, cta_text, isLoginRequired }: { children: ReactNode, url: string, inNewTab?: string, headerName?: string, section_title?: string, cta_text?: string, isLoginRequired: string }) => {
    const router = useRouter()
    const isAuthSuccessOrPerpetual = useAppSelector(selectIsAuthSuccessOrPerpetual,);

    const DlData = {
        component: componentNameConstants.FEATURES_CAROUSEL,
        event: dlEventConstants.CLICK,
        element: dlElementConstants.CLP_CLICK,
        event_type: dlEventConstants.CARD_CLICK,
        cta_text: cta_text || "",
        section_title: section_title || "",
        destination_url: url || "",
    };
    const cleverTapObj = {};
    const handleClickWrapper = (e: React.MouseEvent) => {
        e.stopPropagation();
        
        const args: (string | undefined)[] = [];

        if (inNewTab) args.push(inNewTab);
        if (headerName) args.push(headerName);

        // Check if user is not logged in and card requires login
        if (stringToBoolean(isLoginRequired) && !isAuthSuccessOrPerpetual) {
            // Show login popup instead of redirecting
            store.dispatch(setIsCommonSsoModalVisible(true));
            return;
        }

        handleRedirection(url, router, ...args as [string | undefined, string | undefined]);
        dataLayer("", DlData, cleverTapObj);
    };

    return (
        <div onClick={handleClickWrapper} className="contents">
            {children}
        </div>
    );
};

export default RedirectionHandler;